import { useState } from "react";
import {
  Box,
  Card,
  CardMedia,
  CardContent,
  Typography,
  Button,
  Chip,
  Stack,
  Paper,
  IconButton,
  Tooltip,
} from "@mui/material";
import {
  ZoomIn,
  ZoomOut,
  RestartAlt,
  FileUpload,
  BrokenImage,
} from "@mui/icons-material";
import { CORE4 } from "../../../../constants";

const DEFAULT_IMAGE = {CORE4}
export default function ImageDisplay() {
  const [imageSrc, setImageSrc] = useState(DEFAULT_IMAGE);
  const [imageInfo, setImageInfo] = useState({ name: "sample.jpg", size: null });
  const [zoom, setZoom] = useState(1);
  const [error, setError] = useState(false);


  const handleZoomIn = () => setZoom((z) => Math.min(z + 0.25, 3));
  const handleZoomOut = () => setZoom((z) => Math.max(z - 0.25, 0.25));
  const handleReset = () => setZoom(1);

  return (
   
      <Card sx={{ maxWidth: 820, width: "100%", borderRadius: 3, boxShadow: 6 }}>
        {/* Header */}
       
            <CardMedia
              component="img"
              image={CORE4}
              alt={imageInfo.name}
              onError={() => setError(true)}
              sx={{
                maxWidth: "100%",
                maxHeight: "100%",
                objectFit: "contain",
                transform: `scale(${zoom})`,
                transition: "transform 0.2s ease",
              }}
            />
         
      </Card>
  
  );
}